/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import {fetchSignals, fetchSignalsLatest} from "../../api";
import SignalTable from "./SignalTable";
import SignalDetailDrawer from "./SignalDetailDrawer";

const SignalDetailPage = ({ signalKey }) => {
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);


    const handleRowClick = (row) => {
      setSelectedRow(row.data);     // IMPORTANT FIX
      setDrawerOpen(true);
    };

  useEffect(() => {
    fetchSignalsLatest(signalKey).then((res) => {
      console.log('SINGLE SIGNAL RESULT -->',res)
      setRows(res.results || []);
      setSummary(res);
    });
  }, [signalKey]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>{signalKey.replace(/_/g, " ").toUpperCase()}</h2>

      <div style={{ marginBottom: "10px", opacity: 0.7 }}>
        <div><strong>Last Updated:</strong> {summary.run_ts}</div>
        <div><strong>Results:</strong> {rows.length}</div>
      </div>

      <SignalTable
        moduleName={signalKey}
        rows={rows}
        // onRowClick={setSelectedRow}
        onRowClick={handleRowClick}
      />

    <SignalDetailDrawer
      open={drawerOpen}
      data={selectedRow}         // drawer gets only the inner data object
      onClose={() => setDrawerOpen(false)}
    />
    </div>
  );
};

export default SignalDetailPage;
